<template>
    <div class="pt-container">
        <div class="login-title">
            <v-login-status></v-login-status>
        </div>
        <div class="main-content">
            <el-row>
                <div class="pt-header">
                    <div class="pt-logo">
                        <img src="../../../assets/img/logo2.png" width="120" height="40"/>
                    </div>
                    <div style="float: left; background-color: white; width: 3px; height: 40px; margin-top: 20px; margin-left: 5px; margin-right: 5px;"></div>
                    <div class="pt-websitename">
                        <div class="pt-websitename-top">现代农业与食品产业（淀粉改性）专利专题数据库</div>
                    </div>
                </div>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <div class="pt-class"><el-divider direction="vertical"></el-divider>专利分类</div>
                    <div class="nav-title">技术领域</div>
                    <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
                        <el-submenu index="100">
                            <template slot="title">
                                <i v-if="factiveIndex === '100'" class="el-icon-folder-opened"></i>
                                <i v-else class="el-icon-folder"></i>
                                <span>物理改性</span>
                            </template>
                            <el-menu-item index="701" @click="searchInType">热液改性</el-menu-item>
                            <el-menu-item index="702" @click="searchInType">微波改性</el-menu-item>
                            <el-menu-item index="703" @click="searchInType">电场改性</el-menu-item>
                            <el-menu-item index="704" @click="searchInType">电离辐射改性</el-menu-item>
                            <el-menu-item index="705" @click="searchInType">超声改性</el-menu-item>
                            <el-menu-item index="706" @click="searchInType">球磨改性</el-menu-item>
                            <el-menu-item index="707" @click="searchInType">挤压改性</el-menu-item>
                        </el-submenu>
                        <el-submenu index="200">
                            <template slot="title">
                                <i v-if="sactiveIndex === '200'" class="el-icon-folder-opened"></i>
                                <i v-else class="el-icon-folder"></i>
                                <span>化学改性</span>
                            </template>
                            <el-menu-item index="708" @click="searchInType">酸水解改性</el-menu-item>
                            <el-menu-item index="709" @click="searchInType">酯化改性</el-menu-item>
                            <el-menu-item index="710" @click="searchInType">醚化改性</el-menu-item>
                            <el-menu-item index="711" @click="searchInType">氧化改性</el-menu-item>
                            <el-menu-item index="712" @click="searchInType">接枝共聚改性</el-menu-item>
                        </el-submenu>
                        <el-submenu index="300">
                            <template slot="title">
                                <i v-if="sactiveIndex === '300'" class="el-icon-folder-opened"></i>
                                <i v-else class="el-icon-folder"></i>
                                <span>生物改性</span>
                            </template>
                            <el-menu-item index="713" @click="searchInType">酶改性</el-menu-item>
                            <el-menu-item index="714" @click="searchInType">基因改性</el-menu-item>
                        </el-submenu>
                    </el-menu>
                    <div class="nav-title">专利分级</div>
                    <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
                        <el-menu-item index="715" @click="searchInType">核心专利</el-menu-item>
                        <el-menu-item index="716" @click="searchInType">重要专利</el-menu-item>
                        <el-menu-item index="717" @click="searchInType">一般专利</el-menu-item>
                    </el-menu>
                </el-col>
                <el-col :span="18">
                    <div class="pt-menus">
                        <div class="pt-menus-left"><el-divider direction="vertical"></el-divider>专利列表</div>
                        <div class="pt-menus-right">
                            <span :class="lg === 'zh' ? 'pt-lg-zh-focus' : 'pt-lg-zh'" @click="zhSearch">中</span>
                            <span :class="lg === 'en' ? 'pt-lg-en-focus' : 'pt-lg-en'" @click="enSearch">外</span>
                            <el-button class="pt-search-btn" plain type="info" size="medium" icon="el-icon-search" @click="showCustomSearchDialog">自定义检索</el-button>
                        </div>
                    </div>
                    <div class="pt-select">
                        <el-row :gutter="2">
                            <el-col :span="5">
                                <el-select v-model="queryParams.ptType" style="margin-left: 10px;" placeholder="专利类型" @change="handlePatentTypeChange">
                                    <el-option label="专利类型" :value="0"></el-option>
                                    <el-option label="发明专利" :value="1"></el-option>
                                    <el-option label="实用新型专利" :value="2"></el-option>
                                    <el-option label="外观设计专利" :value="3"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="5">
                                <el-select :disabled="lg === 'zh' ? false : true" v-model="queryParams.proposerType" placeholder="申请人类型" @change="handleApplyChange">
                                    <el-option label="申请人类型" :value="0"></el-option>
                                    <el-option label="机关团体" :value="3"></el-option>
                                    <el-option label="大专院校" :value="2"></el-option>
                                    <el-option label="科研单位" :value="5"></el-option>
                                    <el-option label="个人" :value="4"></el-option>
                                    <el-option label="工矿企业" :value="1"></el-option>
                                    <el-option label="其他" :value="6"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3">
                                <el-select :disabled="lg === 'zh' ? false : true" v-model="queryParams.lawStatus" placeholder="法律状态" @change="handlelawStatusChange">
                                    <el-option label="法律状态" :value="0"></el-option>
                                    <el-option label="有权" :value="2"></el-option>
                                    <el-option label="失效" :value="4"></el-option>
                                    <el-option label="届满" :value="5"></el-option>
                                    <el-option label="在审" :value="1"></el-option>
                                    <el-option label="无权" :value="3"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4">
                                <el-select :disabled="lg === 'zh' ? true : false" v-model="queryParams.appCoun" placeholder="申请人国别" @change="handleCountryChange">
                                    <el-option v-for="item in countryNames" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4">
                                <el-select v-model="patentOrder" placeholder="排序" @change="handleSortChange">
                                    <el-option label="排序" :value="0"></el-option>
                                    <el-option label="申请日升序" :value="1">
                                        <span style="float: left">申请日升序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-top"></i></span>
                                    </el-option>
                                    <el-option label="申请日降序" :value="2">
                                        <span style="float: left">申请日降序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-bottom"></i></span>
                                    </el-option>
                                    <el-option label="公开日升序" :value="3">
                                        <span style="float: left">公开日升序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-top"></i></span>
                                    </el-option>
                                    <el-option label="公开日降序" :value="4">
                                        <span style="float: left">公开日降序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-bottom"></i></span>
                                    </el-option>
                                    <el-option v-show="lg === 'zh'" label="授权日升序" :value="5">
                                        <span style="float: left">授权日升序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-top"></i></span>
                                    </el-option>
                                    <el-option v-show="lg === 'zh'" label="授权日降序" :value="6">
                                        <span style="float: left">授权日降序</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-bottom"></i></span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="1">
                                <el-button :disabled="lg === 'zh' ? false : true" @click="showReport" plain type="warning" icon="el-icon-pie-chart">分析</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="pt-info-list">
                        <el-table :data="patentDataList" style="width: 100%" :border="false" :show-header="false" stripe @row-click="selectRow">
                            <el-table-column prop="date" label="日期">
                                <template slot-scope="scope">
                                    <v-list-item :data="scope.row"></v-list-item>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pt-info-page">
                        <el-pagination 
                            background 
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryParams.pageNo"
                            :page-sizes="[10, 50]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next" 
                            :total="patentDataTotal">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <div class="pt-footer">
                    <div class="pt-footer-1">
                        公司地址：广州市天河区金颖路1号金颖大厦16楼<br/>
                        联系电话：020-38743199；38744550；85294797；38550992；38550875；38550767     邮编：510640
                    </div>
                </div>
            </el-row>
        </div>


        <!-- 专利详情页面 -->
        <el-dialog :title="'专利详情：' + showDetailTitle" :visible.sync="showPatentDetailDialog" v-if="showPatentDetailDialog" width="1000px">
            <div slot="title">
                <v-dialog-title :data="currentDetailPatent"></v-dialog-title>
            </div>
            <v-pt-detail :data="currentDetailPatent"></v-pt-detail>
        </el-dialog>


        <!-- 专利分析页面 -->
        <el-dialog title="专利检索分析" :visible.sync="showReportDialog" v-if="showReportDialog" width="1160px" top="5vh">
            <div slot="title" style="font-size: 20px; font-weight: bold; color: #409EFF;">检索分析</div>
            <!-- <v-main :data="searchDecision"></v-main> -->
            <v-main2 :data="searchDecision"></v-main2>
        </el-dialog>


        <!-- 自定义检索 -->
        <el-dialog title="自定义检索" :visible.sync="showDetailSearchDialog" width="800px">
            <v-search ref="customSearchDialogRef" @onSearch="doRealCustomSearch"></v-search>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDetailSearchDialog = false">取 消</el-button>
                <el-button type="primary" @click="sendCustomSearchEvent">搜 索</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import vLoginStatus from '../../common/LoginStatus.vue';
import vListItem from './PtNyListItem.vue';
import vPtDetail from './PtNyDetail.vue';
import vSearch from './plus/Search.vue';
import vMain from './analysis/Main.vue';
import vMain2 from './analysis/Main2.vue';
import vDialogTitle from './detail/DialogTitle.vue';
export default {
    components: {
        vListItem,
        vPtDetail,
        vSearch,
        vMain,
        vDialogTitle,
        vMain2,
        vLoginStatus
    },
    data() {
        return {
            showPatentDetailDialog: false,
            showReportDialog: false,
            showDetailSearchDialog: false,
            factiveIndex: '0',
            sactiveIndex: '0',
            activeIndex3: '0',
            activeIndex4: '0',
            activeIndex5: '0',
            activeIndex6: '0',
            activeIndex7: '0',
            activeIndex8: '0',
            activeIndex9: '0',
            lg: 'zh',   // 中英文切换, zh/en
            queryParams: {
                ptType: 0,
                proposerType: 0,
                sortFeild: 0,
                sortType: 0,
                lawStatus: 0,
                appCoun: '',
                pageNo: 1,
                pageSize: 10
            },
            patentOrder: 0,
            patentDataList: [],
            patentDataTotal: 0,
            currentSelectMenu: null,
            showDetailTitle: '',
            currentDetailPatent: {},
            // 检索决策数据
            searchDecision: {
                st: 0,  // 检索类型，1：类型检索，2：中文自定义检索，3：英文自定义检索
                lang: 'zh',   // 语言类型，‘zh’中文，‘en’英文
                params: null,   // 检索参数
                type: '',   // 家用电器专利分类
                analysis: 1,  // 0自定义菜单检索，1类型菜单检索
            },
            countryNames: []
        }
    },
    created() {
        this.loadCountryNames();
    },
    methods: {
        async loadCountryNames() {
            const { data: res } = await this.$http.get("search/country/names");
            if (res.code == 0) {
                this.countryNames = res.data;
            }
        },
        handleOpen(key, keyPath) {
            switch (key) {
                case '100':
                    this.factiveIndex = key;
                    break;
                case '200':
                    this.sactiveIndex = key;
                    break;
                case '600':
                    this.activeIndex3 = key;
                    break;
                case '700':
                    this.activeIndex4 = key;
                    break;
                case '800':
                    this.activeIndex5 = key;
                    break;
                case '900':
                    this.activeIndex6 = key;
                    break;
                case '170':
                    this.activeIndex7 = key;
                    break;
                case '180':
                    this.activeIndex8 = key;
                    break;
                case '190':
                    this.activeIndex9 = key;
                    break;
                default:
                    break;
            }
        },
        handleClose(key, keyPath) {
            switch (key) {
                case '100':
                    this.factiveIndex = '0';
                    break;
                case '200':
                    this.sactiveIndex = '0';
                    break;
                case '600':
                    this.activeIndex3 = '0';
                    break;
                case '700':
                    this.activeIndex4 = '0';
                    break;
                case '800':
                    this.activeIndex5 = '0';
                    break;
                case '900':
                    this.activeIndex6 = '0';
                    break;
                case '170':
                    this.activeIndex7 = '0';
                    break;
                case '180':
                    this.activeIndex8 = '0';
                    break;
                case '190':
                    this.activeIndex9 = '0';
                    break;
                default:
                    break;
            }
        },
        handleSizeChange(newSize) {
            this.queryParams.pageSize = newSize;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            this.loadPatantDatas();
        },
        handleCurrentChange(newPage) {
            this.queryParams.pageNo = newPage;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            this.loadPatantDatas();
        },
        handlePatentTypeChange() {
            // 选择类型过滤
            this.searchDecision.params.ptType = this.queryParams.ptType;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            this.loadPatantDatas();
        },
        handleApplyChange() {
            // 选择申请人类型
            this.searchDecision.params.proposerType = this.queryParams.proposerType;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            this.loadPatantDatas();
        },
        handlelawStatusChange() {
            // 选择法律类型
            this.searchDecision.params.lawStatus = this.queryParams.lawStatus;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            this.loadPatantDatas();
        },
        handleCountryChange() {
            // 选择国别
            this.searchDecision.params.appCoun = this.queryParams.appCoun;
            this.searchDecision.params.pageNo = this.queryParams.pageNo;
            this.searchDecision.params.pageSize = this.queryParams.pageSize;
            this.loadPatantDatas();
        },
        handleSortChange() {
            // 选择排序
            this.loadPatantDatas();
        },
        findOrder() {
            switch (this.patentOrder) {
                case 1:
                    this.queryParams.sortFeild = 1;
                    this.queryParams.sortType = 1;
                    break;
                case 2:
                    this.queryParams.sortFeild = 1;
                    this.queryParams.sortType = 2;
                    break;
                case 3:
                    this.queryParams.sortFeild = 2;
                    this.queryParams.sortType = 1;
                    break;
                case 4:
                    this.queryParams.sortFeild = 2;
                    this.queryParams.sortType = 2;
                    break;
                case 5:
                    this.queryParams.sortFeild = 3;
                    this.queryParams.sortType = 1;
                    break;
                case 6:
                    this.queryParams.sortFeild = 3;
                    this.queryParams.sortType = 2;
                    break;
                default:
                    this.queryParams.sortFeild = 0;
                    this.queryParams.sortType = 0;
                    break;
            }

            this.searchDecision.params.sortFeild = this.queryParams.sortFeild;
            this.searchDecision.params.sortType = this.queryParams.sortType;
        },
        searchInType(data) {
            // this.lg = 'zh';
            this.queryParams.pageNo = 1;
            this.queryParams.ptType = 0;
            this.queryParams.proposerType = 0;
            this.queryParams.lawStatus = 0;
            this.patentOrder = 0;
            this.currentSelectMenu = data;
            this.searchDecision.st = 1;
            // this.searchDecision.lang = 'zh';
            this.searchDecision.params = this.queryParams;
            this.searchDecision.type = data.index;
            this.loadPatantDatas();
        },
        async loadPatantDatas() {
            var url = "";
            if (this.searchDecision.type === '715' || this.searchDecision.type === '716' || this.searchDecision.type === '717') {
                var level = 0;
                if (this.searchDecision.type === '715') {
                    level = 0;
                } else if (this.searchDecision.type === '716') {
                    level = 1;
                } else {
                    level = 2;
                }
                if (this.searchDecision.st === 1) {
                    // 类型检索
                    if (this.currentSelectMenu === null) {
                        this.$message.error('请先选择一个分类');
                        return;
                    }

                    if (this.searchDecision.lang === 'zh') {
                        // 中文的检索路径
                        url = "search/levelSearch/70/" + level;
                    } else {
                        // 英文的检索路径
                        url = "search/en/typeSearch/" + this.currentSelectMenu.index;
                    }
                } else if (this.searchDecision.st === 2) {
                    // 中文自定义检索
                    url = "search/custom/ny/search";
                } else if (this.searchDecision.st === 3) {
                    // 英文自定义检索
                    url = "search/custom/en/search/70";
                }
            } else {
                if (this.searchDecision.st === 1) {
                    // 类型检索
                    if (this.currentSelectMenu === null) {
                        this.$message.error('请先选择一个分类');
                        return;
                    }

                    if (this.searchDecision.lang === 'zh') {
                        // 中文的检索路径
                        url = "search/typeSearch/" + this.currentSelectMenu.index;
                    } else {
                        // 英文的检索路径
                        url = "search/en/typeSearch/" + this.currentSelectMenu.index;
                    }
                } else if (this.searchDecision.st === 2) {
                    // 中文自定义检索
                    url = "search/custom/ny/search";
                } else if (this.searchDecision.st === 3) {
                    // 英文自定义检索
                    url = "search/custom/en/search/70";
                }
            }

            this.findOrder();
            const { data: res } = await this.$http.post(url, this.searchDecision.params);
            if (res.code == 0) {
                if (res.data == null) {
                    this.$message.error('没有数据');
                    this.patentDataList = [];
                    this.patentDataTotal = 0;
                    return;
                }

                this.patentDataList = res.data.list;
                this.patentDataTotal = res.data.total;

                // 保存检索条件
                localStorage.setItem("searchInfo", JSON.stringify(this.searchDecision));
            } else {
                this.$message.error(res.msg);
            }
        },
        showCustomSearchDialog() {
            this.showDetailSearchDialog = true;
        },
        sendCustomSearchEvent() {
            this.$refs.customSearchDialogRef.doSearch();
        },
        doRealCustomSearch(data) {
            this.lg = data.searchType;
            if (data.searchType === 'zh') {
                // 中文检索
                this.doZhCustomSearch(data.params);
            } else {
                // 英文检索
                this.doEnCustomSearch(data.params);
            }
        },
        doZhCustomSearch(params) {
            // 反写参数
            this.patentOrder = 0;
            this.queryParams.pageNo = 1;
            this.queryParams.ptType = params.ptType;
            this.queryParams.proposerType = params.proposerType;
            this.queryParams.lawStatus = params.lawStatus;

            params.pageNo = this.queryParams.pageNo;
            params.pageSize = this.queryParams.pageSize;

            this.searchDecision.st = 2;
            this.searchDecision.lang = 'zh';
            this.searchDecision.type = '';
            this.searchDecision.params = params;

            this.showDetailSearchDialog = false;
            this.loadPatantDatas();
        },
        doEnCustomSearch(params) {
            // 反写参数
            this.patentOrder = 0;
            this.queryParams.pageNo = 1;
            this.queryParams.ptType = params.ptType;
            this.queryParams.proposerType = params.proposerType;
            this.queryParams.lawStatus = params.lawStatus;

            params.pageNo = this.queryParams.pageNo;
            params.pageSize = this.queryParams.pageSize;

            this.searchDecision.st = 3;
            this.searchDecision.lang = 'en';
            this.searchDecision.type = '';
            this.searchDecision.params = params;

            this.showDetailSearchDialog = false;
            this.loadPatantDatas();
        },
        zhSearch() {
            // if (this.searchDecision.st !== 1) {
            //     // 只有类型检索才需要切换
            //     return;
            // }
            this.lg = 'zh';
            this.searchDecision.lang = 'zh';
            // this.loadPatantDatas();
        },
        enSearch() {
            // if (this.searchDecision.st !== 1) {
            //     // 只有类型检索才需要切换
            //     return;
            // }
            this.lg = 'en';
            this.searchDecision.lang = 'en';
            // this.loadPatantDatas();
        },
        async loadPatentDetail(row) {
            var url = "search/ptdetail";
            var param = {
                openNo: row.openNo
            };
            if (this.lg === 'en') {
                url = "search/en/ptdetail";
                param = {
                    mtype: 70,
                    appno: row.ptNo
                };
            }
            const { data: res } = await this.$http.get(url, {
                params: param
            });
            if (res.code == 0) {
                this.currentDetailPatent = {
                    lg: this.lg === 'en' ? 1 : 0,
                    baseInfo: row,
                    detail: res.data
                };
                this.showPatentDetailDialog = true;
            } else {
                this.$message.error(res.msg);
            }
        },
        selectRow(row, column, event) {
            this.currentDetailPatent = {};
            this.showDetailTitle = row.ptName;
            this.loadPatentDetail(row);
        },
        showReport() {
            // if (this.searchDecision.st === 0) {
            //     this.$message.error('请先检索专利数据');
            //     return;
            // }
            this.showReportDialog = true;
        },
    }
}
</script>

<style scoped>
.nav-title {
    width: 100%; 
    height: 40px; 
    background-color: rgb(7, 54, 125); 
    line-height: 40px; 
    font-size: 20px; 
    color: white; 
    text-indent: 1em;
}
.login-title {
    width: 100%;
    height: 30px;
    background-color: white;
    border-bottom: 1px solid rgb(194, 194, 194);
}
.pt-container {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    background-color: #f5f6f7;
}

.pt-header {
    width: 100%;
    height: 80px;
    background-color: rgb(7, 54, 125);
    border-bottom: 1px solid #ebeef5;
}

.pt-logo {
    width: 120px;
    height: 40px;
    margin-top: 20px;
    margin-left: 20px;
    float: left;
}

.pt-websitename {
    width: 800px;
    height: 80px;
    float: left;
    font-size: 24px;
}

.pt-websitename-top {
    margin-top: 15px;
    font-size: 32px;
    color: rgb(255, 255, 255);
}
.pt-websitename-bom {
    font-size: 12px;
}

.pt-footer {
    width: 100%;
    height: 120px;
    background-color: #222;
}

.pt-footer-1 {
    width: 60%;
    height: 40px;
    float: left;
    font-size: 12px;
    line-height: 30px;
    margin-top: 30px;
    margin-left: 40px;
    color: white;
}

.pt-footer-2 {
    width: 45%;
    height: 40px;
    float: left;
    font-size: 12px;
    line-height: 30px;
    margin-top: 30px;
    margin-left: 40px;
    color: white;
}

.main-content {
    width: 1160px;
    min-width: 1160px;
    height: 100%;
    margin: auto;
    background-color: white;
}

.el-menu-vertical-demo {
    height: calc(100vh - 485px);
    overflow-y: auto;
}
.pt-class {
    width: 99.6%;
    height: 60px;
    line-height: 60px;
    text-indent: 1em;
    font-size: 18px;
    color: rgb(7, 54, 125);
    border-bottom: 1px solid #ebeef5;
    /* border-right: 1px solid #ebeef5; */
}
.pt-menus {
    width: 100%;
    height: 60px;
    line-height: 60px;
    /* text-indent: 1em; */
    font-size: 18px;
    color: rgb(7, 54, 125);
    border-bottom: 1px solid #ebeef5;
}
.pt-menus-left {
    width: 20%;
    height: 60px;
    float: left;
}
.pt-menus-right {
    width: 80%;
    height: 60px;
    float: left;
    text-align: right;
}
.pt-search-btn {
    margin-right: 32px;
}
.pt-select {
    margin-top: 10px;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ebeef5;
}
.pt-info-list {
    width: 100%;
    height: calc(100vh - 0px);
    overflow-y: auto;
    background-color: white;
}
.pt-info-page {
    width: 100%;
    height: 55px;
    text-align: center;
    background-color: white;
}
.pt-lg-zh {
    background-color: #fef0f0;
    color: #F56C6C;
    border: 1px solid #fbc4c4;
    font-size: 12px;
    padding: 8px 10px 8px 10px;
    border-radius: 32px;
    cursor: pointer;
    margin-right: 10px;
}
.pt-lg-zh-focus {
    background-color: #F56C6C;
    color: #FFF;
    border: 1px solid #F56C6C;
    font-size: 12px;
    padding: 8px 10px 8px 10px;
    border-radius: 32px;
    cursor: pointer;
    margin-right: 10px;
}
.pt-lg-en {
    background-color: rgb(189, 204, 255);
    color: rgb(83, 120, 255);
    border: 1px solid rgb(142, 166, 255);
    font-size: 12px;
    padding: 8px 10px 8px 10px;
    border-radius: 32px;
    cursor: pointer;
    margin-right: 10px;
}
.pt-lg-en-focus {
    background-color: rgb(108, 127, 196);
    color: white;
    border: 1px solid rgb(108, 127, 196);
    font-size: 12px;
    padding: 8px 10px 8px 10px;
    border-radius: 32px;
    cursor: pointer;
    margin-right: 10px;
}
</style>